'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'sack';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f81c';
var svgPathData = 'M184 112l144 0 37.3-74.5c1.8-3.6 2.7-7.6 2.7-11.6 0-14.3-11.6-25.9-25.9-25.9L169.9 0c-14.3 0-25.9 11.6-25.9 25.9 0 4 .9 8 2.7 11.6L184 112zm158.4 48l-172.8 0-48.7 40.6C54.4 256 16 338 16 424.5 16 472.8 55.2 512 103.5 512l305.1 0c48.3 0 87.5-39.2 87.5-87.5 0-86.5-38.4-168.6-104.9-224L342.4 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;